// import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  // NOTE: put styles here
  endAdorment: {
    margin: '0',
    padding: '0',
    '& .MuiIconButton-root': {
      padding: '0'
    }
  }
});
export default useStyles;